import React, { useContext, useState } from "react"
import Axios from "axios"
import AuthContext from "@/context/auth.context"
import { useLocation } from "react-router-dom"
import { message } from "antd"

type IState = {
  data: any
  error: null | string
  loading: boolean
  request: any
}

export default (apiFunc?: any): IState => {
  const [data, setData] = useState(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const { handleNeedsAuthentication } = useContext(AuthContext)

  const request = async (params: any) => {
    setLoading(true)
    setError(null)
    try {
      const { data } = await apiFunc(params)
      setData(data)
    } catch (err) {
      if (Axios.isAxiosError(err)) {
        if (err.message === "Network Error") {
          message.error("Cant reach authentication server")
          return
        }
        setError(err.message || "Unexpected Error!")
        const status = err.response?.status
        if (status === 401) {
          handleNeedsAuthentication(true, location.pathname, async () => {
            try {
              let res = await apiFunc(params)
              setData(res.data)
            } catch (e) {}
          })
        }
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    data,
    error,
    loading,
    request,
  }
}
